import React from "react";
import { STATUS_STYLE as STATUS } from "./DiemDanh";

// Import từ DiemDanh.js - dùng chung STATUS_STYLE

const DiemDanhDesktop = ({
  paginated, filtered, diemDanh, ghiChu, historyMap, hsFullStats,
  tongBuoiDaDD, page, totalPages, PER_PAGE, namHoc, hocKy,
  coThayDoi, saved, setPage, setTrangThai, setGhiChuHS, openHistory,
  TRANG_THAI, STATUS_STYLE
}) => {
  return (
    <div className="bg-surface rounded-2xl shadow-sm border border-outline-variant overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-left">
          <thead>
            <tr className="bg-surface-container-low border-b border-outline-variant">
              <th className="py-3 px-4 font-label-caps text-label-caps text-on-surface-variant w-12">#</th>
              <th className="py-3 px-4 font-label-caps text-label-caps text-on-surface-variant">Tên Thánh</th>
              <th className="py-3 px-4 font-label-caps text-label-caps text-on-surface-variant">Họ và Tên</th>
              <th className="py-3 px-4 font-label-caps text-label-caps text-on-surface-variant">Trạng thái</th>
              <th className="py-3 px-4 font-label-caps text-label-caps text-on-surface-variant">Ghi chú</th>
              <th className="py-3 px-4 font-label-caps text-label-caps text-on-surface-variant w-28">Lịch sử</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-outline-variant/30">
            {paginated.length === 0 && (
              <tr><td colSpan={6} className="text-center py-12 text-on-surface-variant">
                <span className="material-symbols-outlined text-[40px]">search_off</span>
                <p className="mt-2">Không tìm thấy học sinh</p>
              </td></tr>
            )}
            {paginated.map((hs, idx) => {
              const tt = diemDanh[hs.id];
              const dots = historyMap[hs.id] || [];
              const stat = hsFullStats[hs.id];
              const stt = (page - 1) * PER_PAGE + idx + 1;
              return (
                <tr key={hs.id} className="hover:bg-surface-container-low transition-colors">
                  <td className="py-2.5 px-4 text-body-md text-on-surface-variant">{stt}</td>
                  <td className="py-2.5 px-4 text-body-md font-semibold text-primary">{hs.tenThanh || '—'}</td>
                  <td className="py-2.5 px-4 text-body-md">{hs.hoTen}</td>
                  <td className="py-2.5 px-4">
                    <div className="flex items-center gap-1">
                      {Object.entries(TRANG_THAI).map(([k, v]) => {
                        const s = STATUS_STYLE[k];
                        const isActive = tt === k;
                        return (
                          <button key={k} onClick={() => setTrangThai(hs.id, k)}
                            className={`px-2 py-1 rounded-full text-[11px] font-bold transition-all
                              ${isActive ? `${s.bg} ${s.text} border ${s.border}` : 'text-on-surface-variant/50 hover:bg-surface-container border border-transparent'}`}>{v.label}</button>
                        );
                      })}
                    </div>
                  </td>
                  <td className="py-2.5 px-4">
                    <input type="text" placeholder="..." value={ghiChu[hs.id] || ''}
                      onChange={e => setGhiChuHS(hs.id, e.target.value)}
                      className="w-24 bg-transparent border-b border-outline-variant px-2 py-1 text-caption focus:border-secondary outline-none" />
                  </td>
                  <td className="py-2.5 px-4">
                    <button onClick={() => openHistory(hs)} className="flex items-center gap-1.5" title="Xem lịch sử">
                      <div className="flex gap-0.5">
                        {dots.length > 0 ? dots.map((status, i) => {
                          const s = STATUS_STYLE[status] || STATUS_STYLE['null'];
                          return <div key={i} className={`w-2 h-2 rounded-full ${s.dot}`} title={s.label} />;
                        }) : [...Array(5)].map((_, i) => <div key={i} className="w-2 h-2 rounded-full bg-gray-200" />)}
                      </div>
                      {stat && tongBuoiDaDD > 0 && (
                        <span className={`text-[10px] font-bold ml-1 ${stat.vangKP > 0 ? 'text-error' : 'text-green-600'}`}>{stat.coMat}/{tongBuoiDaDD}</span>
                      )}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Footer */}
      <div className="bg-surface-container-low px-4 py-2 flex items-center justify-between border-t border-outline-variant text-caption text-on-surface-variant">
        <span>Hiển thị {paginated.length}/{filtered.length} HS</span>
        <div className="flex items-center gap-3">
          {tongBuoiDaDD > 0 && <span>{tongBuoiDaDD} buổi • {namHoc} • {hocKy}</span>}
          {coThayDoi && <span className="text-[#FF8F00] font-bold">● Chưa lưu</span>}
          {saved && <span className="text-green-600 font-bold">● Đã lưu</span>}
        </div>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex items-center justify-center gap-1 py-2 border-t border-outline-variant/30">
          <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}
            className="w-8 h-8 rounded-lg flex items-center justify-center hover:bg-surface-container transition-colors disabled:opacity-30">
            <span className="material-symbols-outlined text-[18px]">chevron_left</span>
          </button>
          {Array.from({ length: totalPages }, (_, i) => (
            <button key={i} onClick={() => setPage(i + 1)}
              className={`w-8 h-8 rounded-lg text-sm font-bold transition-colors ${page === i + 1 ? 'bg-primary text-on-primary' : 'hover:bg-surface-container text-on-surface-variant'}`}>
              {i + 1}
            </button>
          ))}
          <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}
            className="w-8 h-8 rounded-lg flex items-center justify-center hover:bg-surface-container transition-colors disabled:opacity-30">
            <span className="material-symbols-outlined text-[18px]">chevron_right</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default DiemDanhDesktop;